export default {
      id: "ic-misc-trad-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-misc-trad-usage",
      toString: function () {
        return this.url;
      }
    }